const CHUNK_KEY_PREFIX = 'chunk'
const CHUNK_KEY_WIDTH = 4
const RAUT_ASSET_DRAWING_ROOT = 'asset-screenshot/rautAssetDrawings'

export interface RautAssetDrawingBundlePathsInput {
  inspectionId: string
  chunkKey: string
  descriptorHash: string
}

export interface ParsedRautAssetDrawingBundlePath {
  inspectionId: string
  chunkKey: string
  descriptorHash: string
  bundlePath: string
  fileName: 'heatmap.png' | 'scan-plan.png' | 'legend.png' | 'descriptor.json'
}

export function createRautAssetDrawingChunkKey(index: number) {
  return `${CHUNK_KEY_PREFIX}-${index.toString().padStart(CHUNK_KEY_WIDTH, '0')}`
}

export function parseRautAssetDrawingChunkIndex(chunkKey: string) {
  const match = chunkKey.match(/^chunk-(\d+)$/)
  if (!match) return undefined

  const parsed = Number.parseInt(match[1], 10)
  return Number.isNaN(parsed) ? undefined : parsed
}

export function buildRautAssetDrawingBundlePaths({
  inspectionId,
  chunkKey,
  descriptorHash,
}: RautAssetDrawingBundlePathsInput) {
  const bundlePath = `${RAUT_ASSET_DRAWING_ROOT}/${inspectionId}/${chunkKey}/${descriptorHash}`

  return {
    bundlePath,
    imagePath: `${bundlePath}/heatmap.png`,
    scanPlanPath: `${bundlePath}/scan-plan.png`,
    legendPath: `${bundlePath}/legend.png`,
    descriptorPath: `${bundlePath}/descriptor.json`,
  }
}

export function parseRautAssetDrawingBundlePath(
  path: string | undefined
): ParsedRautAssetDrawingBundlePath | undefined {
  if (!path) return undefined

  const match = path.match(
    /^asset-screenshot\/rautAssetDrawings\/([^/]+)\/([^/]+)\/([^/]+)\/(heatmap\.png|scan-plan\.png|legend\.png|descriptor\.json)$/
  )
  if (!match) return undefined

  const [, inspectionId, chunkKey, descriptorHash, fileNameRaw] = match
  const fileName = fileNameRaw as ParsedRautAssetDrawingBundlePath['fileName']
  const bundlePath = path.slice(0, path.length - fileName.length - 1)

  return {
    inspectionId,
    chunkKey,
    descriptorHash,
    bundlePath,
    fileName,
  }
}

export function getRautAssetDrawingBundleFilePaths(bundle: {
  imagePath: string
  scanPlanPath?: string
  legendPath?: string
  descriptorPath?: string
}) {
  return [
    bundle.imagePath,
    bundle.scanPlanPath,
    bundle.legendPath,
    bundle.descriptorPath,
  ].filter(Boolean) as string[]
}

export function serializeRautAssetDrawingDescriptor(descriptor: unknown) {
  return JSON.stringify(descriptor, null, 2)
}
